/* eslint-disable eqeqeq */
import React, { useEffect } from "react";
import { useSubheader } from "../../../_metronic/layout";
import {
  RestlessTable,
  RestlessButtonFormatter
} from "../../../_metronic/layout/components/Table";
import { useDispatch, useSelector } from "react-redux";
import { articlesHide, contentHided, fetchReportsResolved, hideComments } from "../../../redux/actions/reports";
import RestlessDateFormatter from "../../../_metronic/layout/components/Table/RestlessDateFormatter";
import RestlessCategoryFormatter from "../../../_metronic/layout/components/Table/RestlessCategoryFormatter";
import RestlessReportContent from "../../../_metronic/layout/components/Table/RestlessReportContent";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Route, Switch } from "react-router-dom";
import PostsDetailsDialog from "./RestlessPostsDialog/PostsDetailsDialog";
import { fetchImageToken } from "../../../redux/actions/imageAuth";
import RestlessModerationModal from "../../../_metronic/layout/components/modeationModal/RestlessModerationModal";
import {
  disabledUser,
  kickedUser,
  shadowbanUser,
} from "../../../redux/actions/users";
import { Alert } from "react-bootstrap";
import CommentsDetailsDialog from "./RestlessCommentsDialog/RestlessCommentsDialog";
import RestlessContentReviewDialog from "./RestlessContentReview/RestlessContentReviewDialog";
import RestlessBooleanFormatter from "../../../_metronic/layout/components/Table/RestlessBooleanFormattear";

export default function RestlessReportsReviewedPage({ history }) {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Reports");

  const dispatch = useDispatch();
  const { reportsList, listLoading, hideLoading, postHided, error } = useSelector(
    (state) => ({
      reportsList: state.reports.reportsList,
      listLoading: state.reports.listLoading,
      hideLoading: state.reports.hideLoading,
      postHided: state.reports.postHided,
      error: state.reports.error,
    })
  );

  useEffect(() => {
    dispatch(fetchImageToken());
    dispatch(fetchReportsResolved());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //Array of buttons, atributes = onClickFunction, text, icon
  const buttonsArr = [
    {
      onClickFunction: (row) => {
        if (row.type == 'Comment') {
          return commentsUIEvents.openCommentsDetailsDialog(row);
        }
        if (row.type == 'Post') {
          return postsUIEvents.openPostsDetailsDialog(row);
        }
        
      },
      icon: (
        <SVG title="Detail" src={toAbsoluteUrl("/media/svg/icons/Text/Bullet-list.svg")} />
      ),
      title: "Detail"
    },
    {
      onClickFunction: (row) => {
        if (row.type == 'Post') {
          return postsUIEvents.openModeratePostsDialog(row);
        }
        if (row.type == 'Comment') {
          return commentsUIEvents.openModerateCommentsDialog(row);
        }
        
      },
      disabled: true,
      icon: (
        <SVG title="Moderate" src={toAbsoluteUrl("/media/svg/icons/General/Settings-1.svg")} />
      ),
      title: "Moderate"
    },
    {
      onClickFunction: (row) => {
          return reviewContentUIEvents.openReviewContentDialog(row);
      },
      icon: (
        <SVG title="Monitor" src={toAbsoluteUrl("/media/svg/icons/Communication/Clipboard-check.svg")} />
      ),
      title: "Monitor"
    },
  ];

  //Functions to open the dialog
  const postsUIEvents = {
    openPostsDetailsDialog: (row) => {
      history.push({
        pathname: `/reviewedreports/${row.id}/details`,
        state: { row: row },
      });
    },
    openModeratePostsDialog: (row) => {
      history.push({
        pathname: `/reviewedreports/${row.id}/moderate`,
        state: { row: row },
      });
    },
  };

  //Functions to open the dialog
  const commentsUIEvents = {
    openCommentsDetailsDialog: (row) => {
      history.push({
        pathname: `/reviewedreports/${row.id}/details`,
        state: { row: row },
      });
    },
    openModerateCommentsDialog: (row) => {
      history.push({
        pathname: `/reviewedreports/${row.id}/moderate`,
        state: { row: row },
      });
    },
  };

  //Functions to open the dialog for Review Content
  const reviewContentUIEvents = {
    openReviewContentDialog: (row) => {
      history.push({
        pathname: `/reviewedreports/${row.id}/reviewcontent`,
        state: { row: row },
      });
    }
  };

  const columns = [
    {
      dataField: "restless_user.full_name",
      text: "Reporter",
      sort: true,
    },
    {
      dataField: "content.id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "published_at",
      text: "Created",
      sort: true,
      formatter: RestlessDateFormatter,
    },
    {
      dataField: "type",
      text: "Type",
      sort: true,
      formatter: RestlessReportContent,
    },
    {
      dataField: "content.deleted",
      text: "Deleted",
      sort: true,
      formatter: RestlessBooleanFormatter,
    },
    {
      dataField: "reason",
      text: "Reason",
      sort: true,
      formatter: RestlessCategoryFormatter,
    },
    {
      dataField: "action1",
      formatter: RestlessButtonFormatter,
      formatExtraData: { buttonsArr },
    },
  ];

  const onSubmit = (values, row) => {
    if (values.moderateUser && values.userAction === "Disable_on_social") {
      dispatch(disabledUser({ id: row.restless_user.id, disableOnSocial: true }));
    }
    if (values.moderateUser && values.userAction === "Disable_on_self") {
      dispatch(disabledUser({ id: row.restless_user.id, disableOnSelf: true }));
    }

    if (values.moderateUser && values.userAction === "Kickout") {
      dispatch(kickedUser(row.restless_user.id));
    }
    if (values.moderateUser && values.userAction === "Shadowban") {
      dispatch(shadowbanUser(row.restless_user.id));
    }

    if (row.type == 'Post') {
      dispatch(contentHided(values,row.content.id));
    }
    if (row.type == 'Comment') {
      dispatch(hideComments(values,row.content.id));
    }
    if (row.type == 'Article') {
      dispatch(articlesHide(values,row.content.id));
    }

    history.push("/reviewedreports");
  };
  const renderPostModerationStatus = () => {
    return (
      <Alert variant="success" className="text-center" dismissible>
        The content has been deleted succesfully
      </Alert>
    );
  };

  const renderPostModerationError = () => {
    return (
      <Alert variant="danger" className="text-center" dismissible>
        An error has occurred
      </Alert>
    );
  };

  return (
    <>
      {listLoading || hideLoading ? (
        <div className="d-flex justify-content-center align-content-center">
          <span className="mx-3 spinner spinner-primary"></span>
        </div>
      ) : (
        <>
          {!error && postHided && renderPostModerationStatus()}
          {error && !postHided && renderPostModerationError()}
          <Switch>
            <Route path="/reviewedreports/:id/details">
            {({ history, match }) => {
                if(history.location.state?.row.type == 'Post') {
                  return <PostsDetailsDialog
                  show={match != null}
                  id={match && match.params.id}
                  row={history.location.state?.row}
                  onHide={() => {
                    history.push("/reviewedreports");
                  }}
                /> 
                }
                if(history.location.state?.row.type == 'Comment') {
                  return <CommentsDetailsDialog
                  show={match != null}
                  id={match && match.params.id}
                  row={history.location.state?.row}
                  onHide={() => {
                    history.push("/reviewedreports");
                  }}
                /> 
                }
             }}
            </Route>
            <Route path="/reviewedreports/:id/moderate">
              {({ history, match }) => (
                <RestlessModerationModal
                  show={match != null}
                  id={match && match.params.id}
                  row={history.location.state?.row}
                  onSubmit={onSubmit}
                  onHide={() => {
                    history.push("/reviewedreports");
                  }}
                  entityType={history.location.state?.row.type}
                />
              )}
            </Route>
            <Route path="/reviewedreports/:id/reviewcontent">
              {({ history, match }) => (
                  <RestlessContentReviewDialog
                  show={match != null}
                  id={match && match.params.id}
                  row={history.location.state?.row}
                  onHide={() => {
                    history.push("/reviewedreports");
                  }}
                />
              )}
            </Route>
          </Switch>
          <RestlessTable data={reportsList} columns={columns} withPagination />
        </>
      )}
    </>
  );
}
